import html2canvas from "html2canvas";
import { UploadedFileDto } from "../supportIntegrationSlice";

export const downloadAttachment = (attachment: UploadedFileDto) => {
    if (!attachment.fileData) return;

    const encodedData = attachment.fileData.includes(",")
        ? attachment.fileData.split(",", 2)[1]
        : attachment.fileData;
    const bytes = Uint8Array.from(atob(encodedData), character => character.charCodeAt(0));
    const url = URL.createObjectURL(new Blob([bytes], { type: attachment.contentType }));
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = attachment.fileName;
    anchor.click();
    URL.revokeObjectURL(url);
};

export const captureViewport = async (): Promise<Blob> => {
    const canvas = await html2canvas(document.body, {
        width: window.innerWidth,
        height: window.innerHeight,
        windowWidth: window.innerWidth,
        windowHeight: window.innerHeight,
        scrollX: -window.scrollX,
        scrollY: -window.scrollY,
        useCORS: true,
        logging: false,
        ignoreElements: (element) =>
            element.hasAttribute("data-bug-report-exclude"),
    });
    return new Promise((resolve, reject) => {
        canvas.toBlob((blob) => {
            if (blob) {
                resolve(blob);
            } else {
                reject(new Error("Unable to create screenshot"));
            }
        }, "image/png");
    });
};

export const blobToBase64 = (blob: Blob): Promise<string> =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () =>
            resolve(String(reader.result).split(",", 2)[1] ?? "");
        reader.onerror = () => reject(reader.error);
        reader.readAsDataURL(blob);
    });

export const createGuid = () => {
    const bytes = crypto.getRandomValues(new Uint8Array(16));
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;
    const value = Array.from(
        bytes,
        byte => byte.toString(16).padStart(2, "0")
    ).join("");
    return `${value.slice(0, 8)}-${value.slice(8, 12)}-${value.slice(12, 16)}-${value.slice(16, 20)}-${value.slice(20)}`;
};
